import {getTutorialChapter} from '../../configs/tutorial';

/**
 * Идентификаторы метрик обучения (дизайн-события GameAnalytics).
 *
 * Все события главы — ветка `tutorial:<chapterId>`, дальше вид события:
 *
 *   tutorial:tutorial_chapter_1:start:first
 *   tutorial:tutorial_chapter_1:step:01_barba_1:first
 *   tutorial:tutorial_chapter_1:step:08_build_quarter_mine:first
 *   tutorial:tutorial_chapter_1:modal_shown:08_ch1_construction:first
 *   tutorial:tutorial_chapter_1:modal_closed:08_ch1_construction:first
 *   tutorial:tutorial_chapter_1:modal_shown:42_chapter_complete:first
 *
 * Номер — номер ШАГА сценария (индекс в chapter.steps + 1), двумя цифрами:
 * GameAnalytics сортирует узлы по алфавиту, и без нуля «10» встало бы перед
 * «2». Номер один и тот же у события шага, у модалки этого шага, в прогрессе
 * записи прохождения в админке — «шаг 5» везде означает одно место главы.
 *
 * Основная воронка — step: у большинства шагов модалки нет вовсе, а отложенная
 * модалка может не показаться (игрок успел выполнить шаг раньше), так что по
 * одним модалкам «до какого шага дошел» не видно. Модалки — доля шагов, где
 * объяснение реально показали и закрыли. Поздравление с концом главы — номер
 * «шагов + 1», последний узел воронки.
 *
 * Последний уровень — первое это прохождение главы или повторное: повторные
 * иначе раздували бы воронку новичков.
 */

export const TUTORIAL_ANALYTICS_EVENTS = Object.freeze({
  START: 'start',
  STEP: 'step',
  MODAL_SHOWN: 'modal_shown',
  MODAL_CLOSED: 'modal_closed',
});

export const TUTORIAL_CHAPTER_COMPLETE_MODAL_ID = 'chapter_complete';

export const getTutorialRunKind = (isRepeatRun) => (isRepeatRun ? 'repeat' : 'first');

export const formatTutorialStepNumber = (stepIndex) => String(stepIndex + 1).padStart(2, '0');

/**
 * Ключ шага: `<номер>_<id шага>` или null, если такого шага в главе нет
 */
export const getTutorialStepKey = (chapterId, stepIndex) => {
  const step = getTutorialChapter(chapterId)?.steps?.[stepIndex];
  return step ? `${formatTutorialStepNumber(stepIndex)}_${step.id}` : null;
};

/**
 * Ключ модалки: `<номер шага, на котором она показывается>_<id модалки>`.
 * Поздравление с концом главы — номер «шагов + 1». null — модалки в сценарии
 * главы нет (например, зарегистрированная, но не используемая)
 */
export const getTutorialModalKey = (chapterId, modalId) => {
  const chapter = getTutorialChapter(chapterId);
  if (!chapter || !modalId) {
    return null;
  }
  if (modalId === TUTORIAL_CHAPTER_COMPLETE_MODAL_ID) {
    return `${formatTutorialStepNumber(chapter.steps.length)}_${TUTORIAL_CHAPTER_COMPLETE_MODAL_ID}`;
  }
  const stepIndex = chapter.steps.findIndex((step) => step.modalId === modalId);
  return stepIndex >= 0 ? `${formatTutorialStepNumber(stepIndex)}_${modalId}` : null;
};
